import React from "react";

function AboutText() {
  return (
    <div className="about_text">
      <p>
        Hi, my name is Natanael Yulius. I’m in my third year of studies towards
        a bachelor’s in Informatics Engineering at Satya WacanaChristian
        University. I very enthusiastic about software engineering , website
        development , UI/UX design and also Android Development. I’d love to
        interact with people and improve my communication skill. Currently, I
        focus on Android Development after Graduated at Bangkit Academy 2022.
      </p>
    </div>
  );
}

export default AboutText;
